import { lazy, useEffect, useState } from "react";
import Login from "../pages/Login";
import Termination from "../pages/Termination";
import Resignation from "../pages/Resignation";
import Promotion from "../pages/Promotion";
import Categories from "../pages/Categories";
import Budgets from "../pages/Budget";
import BudgetRevenue from "../pages/BudgetRevenue";
import BudgetExpense from "../pages/BudgetExpense";
import CallHistory from "../pages/CallHistory";
import Pipeline from "../pages/Pipeline";
import PerformanceAppraisal from "../pages/PerformanceAppraisal";
import PerformanceIndicator from "../pages/PerfomanceIndicator";
import GoalTracking from "../pages/GoalTracking";
import GoalType from "../pages/GoalType";
import Loan from "../pages/Lon";
import PerformanceReview from "../pages/PerformanceReview";
import Referrals from "../pages/Referrals";
import Notes from "../pages/Notes";
import Projects from "../pages/Projects";
import Jobs from "../pages/Jobs";
import Clients from "../pages/Clients";
import Shortlisted from "../pages/Shortlisted";
import Estimations from "../pages/Estimations";
import Leads from "../pages/Leads";
import Deals from "../pages/Deals";
import Contracts from "../pages/Contracts";
import Assets from "../pages/Assets";
import EmployeePage from "../pages/ajith/EmployeePage";
import Analytics from "../pages/ajith/Analytics";
// import TaskReport from "../pages/ajith/TaskReport";
import DailyReport from "../pages/ajith/DailyReport";
import ProjectsReport from "../pages/ajith/ProjectReport";
import PaymentReport from "../pages/ajith/PaymentReport";
import InvoiceReport from "../pages/ajith/InvoiceReport";
import ExpenseReport from "../pages/ajith/ExpenseReport";
import TaskReport from "../pages/ajith/TaskReport";
import Holidays from "../pages/Holidays";
import Activity from "../pages/Activity";
import Attendance from "../pages/Attedance";
import Leaves from "../pages/Leaves";
import Schedule from "../pages/Schedule";
import AssetCategory from "../pages/AssetsCategory";
import AttendanceReport from "../pages/micheal/AttendanceReport";
import EmployeeReport from "../pages/micheal/EmployeeReport";
import UserReport from "../pages/micheal/UserReport";
import PaySlipReport from "../pages/micheal/PaySlipReport";
import LeaveReport from "../pages/micheal/LeaveReport";
import CompanyReport from "../pages/micheal/CompanyReport";
import Timeline from "../pages/micheal/Timeline";
import Todo from "../pages/micheal/Todo";
import EmployeeJobs from "../pages/micheal/Employee";
import DashboardM from "../pages/micheal/Dashboard";
import Recruitment from "../pages/micheal/Recruitment";
import Report from "../pages/Report";
import Settings from "../pages/settings";
import { Navigate } from "react-router-dom";
import ProfileSettings from "../components/Settings/ProfileSettings";
import NotificationSettings from "../components/Settings/NotificationSettings";
import SecuritySettings from "../components/Settings/SecuritySettings";
import SalarySettings from "../components/Settings/SalarySettings";
import ApprovalSettings from "../components/Settings/ApprovalSettings";
import InvoiceSettings from "../components/Settings/InvoiceSettings";
import LeaveType from "../components/Settings/LeaveType";
import CustomFields from "../components/Settings/CustomFields";

import BusinessForm from "../components/Settings/BusinessForm";

import SeoSettings from "../components/Settings/SeoSettings";
import LocalizationForm from "../components/Settings/LocalizationForm";
import PrefixesForm from "../components/Settings/PrefixesForm";
import Preferences from "../components/Settings/PreferencesForm";
import Appearance from "../components/Settings/AppearenceForm";

import PaymentGateways from "../components/Settings/PaymentGateways";
import TaxRates from "../components/Settings/TaxRates";
import Currencies from "../components/Settings/Currencies";

import SystemEmailSettings from "../components/Settings/SystemEmailSetting";
import EmailTemplate from "../components/Settings/SystemEmailTemplates";
import SystemSmsSettings from "../components/Settings/SystemSmsSettings";
import SystemSmsTemplates from "../components/Settings/SystemSmsTemplates";
import OTPSettings from "../components/Settings/SystemOtpSettings";
import GDPRSettings from "../components/Settings/SystemGdprCookies";
import MaintenanceMode from "../components/Settings/SystemMaintenanceMode";

import OtherCustomCss from "../components/Settings/OtherCustomCss";
import SuperAdmin from "../pages/SuperAdmin";
import ASuperAdmin from "../pages/ajith/ASuperAdmin";
import MSuperAdmin from "../pages/micheal/MSuperAdmin";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const Message = lazy(() => import("../pages/Message"));
const ProjectReview = lazy(() => import("../pages/ProjectReview"));
const AnalyticsDashboard = lazy(() => import("../pages/AnalyticsDashboard"));
const Payroll = lazy(() => import("../pages/Payroll"));
const Idcardaccess = lazy(() => import("../pages/Idcardaccess"));
const Announcement = lazy(() => import("../pages/Announcement"));
const Warning = lazy(() => import("../pages/Warning"));

const DashboardSections = lazy(() => import("../Trash/daa"));

const AppRoutes = () => {
  const [accessRoles, setAccessRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAccessRoles = async () => {
      try {
        const response = await fetch("/api/access-roles");
        const data = await response.json();
        setAccessRoles(data);
      } catch (error) {
        console.error("Failed to fetch access roles", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAccessRoles();
  }, []);

  return [
    {
      path: "/dashboard",
      element: <Dashboard />,
      isPrivate: false,
      roles: accessRoles,
    },
    {
      path: "/project-review",
      element: <ProjectReview />,
      isPrivate: false,
      roles: accessRoles,
    },
    {
      path: "/message",
      element: <Message />,
      isPrivate: false,
      roles: accessRoles,
    },
    {
      path: "/idcard-access",
      element: <Idcardaccess />,
      isPrivate: false,
      roles: accessRoles,
    },
    {
      path: "/analytics",
      element: <AnalyticsDashboard />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/payroll",
      element: <Payroll />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/announcement",
      element: <Announcement />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/warning",
      element: <Warning />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/promotion",
      element: <Promotion />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/resignation",
      element: <Resignation />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/termination",
      element: <Termination />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Categories",
      element: <Categories />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Budget",
      element: <Budgets />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Budget-Revenue",
      element: <BudgetRevenue />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Budget-Expense",
      element: <BudgetExpense />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/call-history",
      element: <CallHistory />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/pipelines",
      element: <Pipeline />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Performance-Appraisal",
      element: <PerformanceAppraisal />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Performance-Indicator",
      element: <PerformanceIndicator />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Goal-Tracking",
      element: <GoalTracking />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Goal-Type",
      element: <GoalType />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Loan",
      element: <Loan />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/performance-review",
      element: <PerformanceReview />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/referrals",
      element: <Referrals />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Notes",
      element: <Notes />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/Projects",
      element: <Projects />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/jobs",
      element: <Jobs />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/clients",
      element: <Clients />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/shortlist",
      element: <Shortlisted />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/estimations",
      element: <Estimations />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/leads",
      element: <Leads />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/deals",
      element: <Deals />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/contracts",
      element: <Contracts />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/reports",
      element: <Report />,
      isPrivate: false,
      // roles: accessRoles,
    },
    {
      path: "/",
      element: <Login />,
      isPrivate: false,
    },
    {
      path: "/assets",
      element: <Assets />,
      isPrivate: false,
    },
    {
      path: "/assets-Category",
      element: <AssetCategory />,
      isPrivate: false,
    },
    {
      path: "/schedule",
      element: <Schedule />,
      isPrivate: false,
    },
    {
      path: "/leaves",
      element: <Leaves />,
      isPrivate: false,
    },
    {
      path: "/attendance",
      element: <Attendance />,
      isPrivate: false,
    },
    {
      path: "/activity",
      element: <Activity />,
      isPrivate: false,
    },
    {
      path: "/holidays",
      element: <Holidays />,
      isPrivate: false,
    },
    // ========================================
    {
      path: "/employees-details",
      element: <EmployeePage />,
      isPrivate: false,
    },
    {
      path: "/analytics_A",
      element: <Analytics />,
      isPrivate: false,
    },

    {
      path: "/reports/task",
      element: <TaskReport />,
      isPrivate: false,
    },
    {
      path: "/reports/daily",
      element: <DailyReport />,
      isPrivate: false,
    },
    {
      path: "/reports/project",
      element: <ProjectsReport />,
      isPrivate: false,
    },
    {
      path: "/reports/payment",
      element: <PaymentReport />,
      isPrivate: false,
    },
    {
      path: "/reports/invoice",
      element: <InvoiceReport />,
      isPrivate: false,
    },
    {
      path: "/reports/expense",
      element: <ExpenseReport />,
      isPrivate: false,
    },

    // ========================================

    {
      path: "/reports/user",
      element: <UserReport />,
      isPrivate: false,
    },
    {
      path: "/reports/attendance",
      element: <AttendanceReport />,
      isPrivate: false,
    },
    {
      path: "/reports/employee",
      element: <EmployeeReport />,
      isPrivate: false,
    },
    {
      path: "/reports/payslip",
      element: <PaySlipReport />,
      isPrivate: false,
    },
    {
      path: "/reports/leave",
      element: <LeaveReport />,
      isPrivate: false,
    },
    {
      path: "/reports/company",
      element: <CompanyReport />,
      isPrivate: false,
    },
    {
      path: "/dashoard_M",
      element: <DashboardM />,
      isPrivate: false,
    },
    {
      path: "/requirements",
      element: <Recruitment />,
      isPrivate: false,
    },
    {
      path: "/employee-jobs",
      element: <EmployeeJobs />,
      isPrivate: false,
    },
    {
      path: "/timeline",
      element: <Timeline />,
      isPrivate: false,
    },
    {
      path: "/todo",
      element: <Todo />,
      isPrivate: false,
    },
    {
      path: "/settings",
      element: <Settings />,
      isPrivate: false,
    },

    // {
    //   path: "settings/general/profile",
    //   element: <ProfileSettings />,
    //   isPrivate: false,
    // },

    {
      path: "/settings",
      element: <Settings />,
      isPrivate: false,
      children: [
        {
          index: true,
          element: <Navigate to="general/profile" replace />,
        },

        // GENERAL
        {
          path: "general/profile",
          element: <ProfileSettings />,
        },
        {
          path: "general/security",
          element: <SecuritySettings />,
        },
        {
          path: "general/notifications",
          element: <NotificationSettings />,
        },

        // APP
        {
          path: "app/salary",
          element: <SalarySettings />,
        },
        {
          path: "app/approval",
          element: <ApprovalSettings />,
        },
        {
          path: "app/invoice",
          element: <InvoiceSettings />,
        },
        {
          path: "app/leave-type",
          element: <LeaveType />,
        },
        {
          path: "app/custom-fields",
          element: <CustomFields />,
        },

        // WEBSITE
        {
          path: "website/business",
          element: <BusinessForm />,
        },
        {
          path: "website/seo",
          element: <SeoSettings />,
        },
        {
          path: "website/localization",
          element: <LocalizationForm />,
        },
        {
          path: "website/prefixes",
          element: <PrefixesForm />,
        },
        {
          path: "website/preferences",
          element: <Preferences />,
        },
        {
          path: "website/appearance",
          element: <Appearance />,
        },

        // FINANCIAL
        {
          path: "financial/payment",
          element: <PaymentGateways />,
        },
        {
          path: "financial/tax",
          element: <TaxRates />,
        },
        {
          path: "financial/currencies",
          element: <Currencies />,
        },

        // SYSTEM
        {
          path: "system/email",
          element: <SystemEmailSettings />,
        },
        {
          path: "system/email-templates",
          element: <EmailTemplate />,
        },
        {
          path: "system/sms",
          element: <SystemSmsSettings />,
        },
        {
          path: "system/sms-templates",
          element: <SystemSmsTemplates />,
        },
        {
          path: "system/otp",
          element: <OTPSettings />,
        },
        {
          path: "system/gdpr",
          element: <GDPRSettings />,
        },
        {
          path: "system/maintenance",
          element: <MaintenanceMode />,
        },

        // OTHER
        {
          path: "other/custom-css",
          element: <OtherCustomCss />,
        },
      ]
    },
    
    {
      path: "super-admin",
      element: <SuperAdmin />,
    },
    {
      path: "Asuper-admin",
      element: <ASuperAdmin />,
    },
    {
      path: "Msuper-admin",
      element: <MSuperAdmin />,
    }
    // ========================================
  ];
};

export default AppRoutes;
